import { fromJS } from "immutable";
import { orderBy, find } from "lodash";
import { reverseMapAllocationType } from "./utils";
import { dateFormatter } from "../../../../utils/commonUtil";
import {
  mapLoadingToResults,
  mapLoadingCancelToResults,
  sortLegalName,
} from "../../../../CommonComponents/CharitySearch/utils";
import * as actionType from "./actionTypes";
import { getGrantDetailsType } from "../GrantsActivity/actionTypes";

const initialState = fromJS({
  loading: true,
  isGrantDetailsLoading: true,
  savedCharities: [],
  recentCharities: [],
  grantedCharity: {
    isLoading: true,
  },
  savedCharity: {
    isLoading: true,
  },
  poolsAllocation: [],
  investmentAllocationData: {
    isLoading: true,
  },
  searchGemini: {
    isLoading: true,
    data: null,
    searchGeminiStringResponse: null,
    isGeminiSearch: false,
    error: "",
  },
  searchCity: {
    isLoading: true,
    data: null,
    error: "",
  },
  searchCounty: {
    isLoading: true,
    data: null,
    error: "",
  },
  cityLoader: {
    isLoading: true,
  },
  countyLoader: {
    isLoading: true,
  },
  charitySaved: false,
  grantPurposeDropdown: [],
  grantPurpose: {
    isLoading: true,
  },
  // Charity Details
  selectedCharityName: "",
  selectedCharityAddress: {},
  selectedCharityId: "",
  selectedCharityEin: "",
  selectedCharityInterest: "",
  selectedCharityRefPath: "/grants/recommend",
  // Purpose
  grantPurposeId: "",
  grantPurposeName: "",
  purposeComments: "",
  missionaryName: "",
  eventName: "",
  missionaryLocation: "",
  projectName: "",
  purposeCertification: false,
  standardLanguage: "",
  // Recognition
  grantRecognition: "",
  honorOf: "",
  memoryOf: "",
  notifyFirstName: "",
  notifyLastName: "",
  advisorThirdPartyComment: "",
  accountName: "",
  permissionToPublish: true,
  includeAdvisorInfo: true,
  // Amount and Schedule
  grantAmount: 0,
  scheduleType: "oneTime",
  startDate: "",
  frequency: "",
  allocationType: "",
  allocations: [],
  noOfPayments: 0,
  allSharesAllPools: false,
  allShares: false,
  // Search
  searchNextApi: 0,
  searchLoadMoreApi: 0,
  searchCharity: {
    isLoading: true,
    data: [],
    isCharitySearch: false,
    error: "",
    guidestarSearchCount: "",
    serverDown: false,
  },
  spawns: [],
  geminiFilter: {
    showFilter: false,
  },
  from: 0,
  einData: "",
  geminiEinData: "",
  searchTerm: null,
  geminiSearchTerm: null,
  edit: false,
  grantId: "",
  pendingSpawnId: null,
  enteredDate: null,
  updateReq: false,
  //cancelStatus
  cancel: false,
  scheduleId: null,
  cancelAll: false,
  updateSpawn: false,
  lazyLoadingFlag: false,
  submitLoading: false,
  regrant: false,
  pendingGrantsLoading: false,
  pendingGrants: [],
  pendingActiveSchedule: [],
  pendingAgreements: [],
  grantHistoryLoading: false,
  grantHistory: [],
  scheduleHistory: [],
  agreementHistory: [],
  contribAndFeeLoading: false,
  poolsPendingContrib: [],
  adminFee: 0,
  checkIssuedDate: "",
  endDate: "",
  checkNumber: "",
  paymentLetterLink: "",
  grantTemplateId: "",
  allocExhaustChecked: false,
  currentPageScroll: null,
  isGrantAgreementPayment: false,
  grantTimeline: [],
  fastPass: '',
  grantAgreementId: null
});

export const filterGrantAgreementData = (unfilteredData) => {
  return unfilteredData.map((data) => ({
    id: data.grantAgreementId,
    remainingPayments: data.pendingPayments,
    endDate: data.gaEndDateString,
  }));
};

const recommendGrant = (state = initialState, action) => {
  switch (action.type) {
    case actionType.newFlowType:
    case actionType.cancelFlowType:
    case getGrantDetailsType: {
      return initialState;
    }
    case actionType.fetchRecentGrantSuccessType: {
      const { grantedCharity = [] } = action.payload;
      return state
        .setIn(["recentCharities"], grantedCharity)
        .setIn(["grantedCharity", "isLoading"], false);
    }

    case actionType.fetchSavedCharitySuccessType: {
      let sortedArray = sortLegalName(action.payload);
      return state
        .setIn(["savedCharities"], sortedArray)
        .setIn(["savedCharity", "isLoading"], false);
    }

    case actionType.submitSavedGeminiDataSuccessType: {
      const submitGeminiData = action.payload;
      const { prevData = {} } = action;

      return state
        .updateIn(["searchGemini", "data"], (geminiResults) =>
          geminiResults.map((record) => {
            if (record.granteeOrgId === prevData.granteeOrgId) {
              record.isPending = action.payload.isPending;
              return {
                ...record,
                isSelected: true,
                granteeOrgAliasId: submitGeminiData.granteeOrgAliasId,
                loading: false,
              };
            }
            return { ...record };
          })
        )
        .setIn(["charitySaved"], true);
    }

    case actionType.submitSavedGeminiDataFailType: {
      const { prevData = {} } = action;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchGemini", "data"], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, "granteeOrgId")
        );
    }

    case actionType.postGeminiSavedDataType: {
      const { charityData = {} } = action.payload;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchGemini", "data"], (searchResults) =>
          mapLoadingToResults(searchResults, charityData, "granteeOrgId")
        );
    }

    case actionType.einDataType: {
      let searchData = state.getIn(["searchCharity", "data"]);
      let searchCharityData = searchData.splice(0);
      let newSearchCharity;
      newSearchCharity = searchCharityData.map((obj) => {
        if (obj.granteeOrgAliasId === action.payload) {
          obj.isSelected = false;
        }
        return obj;
      });
      return state
        .set("einData", action.payload)
        .setIn(["searchCharity", "data"], newSearchCharity);
    }

    case actionType.saveCharityType: {
      const { charityData = {} } = action.payload;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchCharity", "data"], (searchResults) =>
          mapLoadingToResults(searchResults, charityData, "ein")
        );
    }

    case actionType.saveCharitySuccessType: {
      const { prevData = {} } = action;
      return state
        .updateIn(["searchCharity", "data"], (searchResults) =>
          searchResults.map((obj) => {
            if (obj.ein === prevData.ein && action.payload.success) {
              return {
                ...obj,
                charityId: action.payload.charityId,
                granteeOrgAliasId: action.payload.granteeOrgAliasId,
                isSelected: true,
                loading: false,
              };
            }
            return { ...obj };
          })
        )
        .setIn(["charitySaved"], action.payload.success);
    }

    case actionType.addCharityFailType:
    case actionType.saveCharityFailType: {
      const { prevData = {} } = action;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchCharity", "data"], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, "ein")
        );
    }

    case actionType.addCharitySuccessType: {
      const { prevData = {} } = action;
      return state
        .updateIn(["searchCharity", "data"], (searchResults) =>
          searchResults.map((obj) => {
            if (obj.ein === prevData.ein && action.payload) {
              return {
                ...obj,
                charityId: prevData.granteeOrgId,
                granteeOrgAliasId: action.payload,
                isSelected: true,
                loading: false,
              };
            }
            return { ...obj, loading: false };
          })
        )
        .setIn(["charitySaved"], true);
    }

    case actionType.cancelSaveCharityType: {
      const prevData = action.payload;
      return state
        .setIn(["charitySaved"], false)
        .updateIn(["searchCharity", "data"], (searchResults) =>
          mapLoadingCancelToResults(searchResults, prevData, "ein")
        );
    }

    case actionType.searchCharityResponseType: {
      let prevData = state.getIn(["searchCharity", "data"]);
      let lazyLoadingFlag = state.get("lazyLoadingFlag");
      let searchSavedData = state.getIn(["savedCharities"]);
      const searchCharityResponse = action.payload.hits;
      const { serverDown } = action.payload;
      if (prevData === null) {
        // sonar issue: Might be required in future
        // if (searchSavedData.length === 0) {
        //   prevData &&
        //     prevData.map((record) => {
        //       record.isSelected = false;
        //     });
        // }

        loop1: for (let i = 0; i < searchSavedData.length; i++) {
          loop2: for (let j = 0; j < searchCharityResponse.length; j++) {
            if (searchSavedData[i].ein === searchCharityResponse[j].ein) {
              searchCharityResponse[j].isSelected = true;
              searchCharityResponse[j].granteeOrgAliasId =
                searchSavedData[i].granteeOrgAliasId;
              searchCharityResponse[j].charityId = searchSavedData[i].charityId;
              searchCharityResponse[j].isPending = searchSavedData[i].isPending;
              break loop2;
            }
          }
        }
        searchCharityResponse.map((item) => {
          if (!item.isSelected) {
            item.isSelected = false;
          }
        });

        return state
          .setIn(["searchCharity", "data"], searchCharityResponse)
          .setIn(
            ["searchCharity", "guidestarSearchCount"],
            action.payload.total_hits
          )
          .setIn(["searchCharity", "isLoading"], false)
          .setIn(["searchCharity", "serverDown"], serverDown)
          .setIn(["searchCharity", "isCharitySearch"], true);
      } else {
        if (searchSavedData.length === 0) {
          searchCharityResponse.map((record) => {
            record.isSelected = false;
          });
        }
        if (searchCharityResponse.length > 0) {
          loop1: for (let i = 0; i < searchSavedData.length; i++) {
            loop2: for (let j = 0; j < searchCharityResponse.length; j++) {
              if (searchSavedData[i].ein === searchCharityResponse[j].ein) {
                searchCharityResponse[j].isSelected = true;
                searchCharityResponse[j].granteeOrgAliasId =
                  searchSavedData[i].granteeOrgAliasId;
                searchCharityResponse[j].charityId =
                  searchSavedData[i].charityId;
                searchCharityResponse[j].isPending =
                  searchSavedData[i].isPending;
                break loop2;
              }
            }
          }
        }
        searchCharityResponse.map((item) => {
          if (!item.isSelected) {
            item.isSelected = false;
          }
        });
        if (lazyLoadingFlag === true) {
          for (let i = 0; i < searchCharityResponse.length; i++) {
            prevData = [...prevData, searchCharityResponse[i]];
          }
          return state
            .setIn(["searchCharity", "data"], prevData)
            .setIn(
              ["searchCharity", "guidestarSearchCount"],
              action.payload.total_hits
            )
            .setIn(["searchCharity", "isLoading"], false)
            .setIn(["searchCharity", "isCharitySearch"], true)
            .setIn(["searchCharity", "serverDown"], serverDown)
            .set("lazyLoadingFlag", false);
        }

        return state
          .setIn(["searchCharity", "data"], searchCharityResponse)
          .setIn(
            ["searchCharity", "guidestarSearchCount"],
            action.payload.total_hits
          )
          .setIn(["searchCharity", "isLoading"], false)
          .setIn(["searchCharity", "serverDown"], serverDown)
          .setIn(["searchCharity", "isCharitySearch"], true);
      }
    }

    case actionType.updateFromCounterWorkerType: {
      const nextCounter = state.getIn(["searchNextApi"]) + action.payload;
      return state.setIn(["searchNextApi"], nextCounter);
    }
    case actionType.geminiFilterType: {
      return state.setIn(["geminiFilter", "showFilter"], action.payload);
    }
    case actionType.fetchGrantPurposeType: {
      return state
        .setIn(["grantPurposeDropdown"], [])
        .setIn(["grantPurpose", "isLoading"], true);
    }
    case actionType.fetchGrantPurposeSuccessType: {
      const filteredList = action.payload.filter(
        (option) => option.showInDropDown
      );
      const sortedList = orderBy(filteredList, ["displayOrder"], ["asc"]);
      return state
        .setIn(["grantPurposeDropdown"], sortedList)
        .setIn(["grantPurpose", "isLoading"], false);
    }
    case actionType.fetchGrantPurposeFailType: {
      return state.setIn(["grantPurpose", "isLoading"], false);
    }
    case actionType.fetchAllocationDataLoadingType: {
      return state
        .setIn(["investmentAllocationData", "isLoading"], true)
        .setIn(["poolsAllocation"], []);
    }
    case actionType.fetchAllocationDataSuccessType: {
      const poolsData = action.payload.data.investmentPools;
      const requiredData = poolsData.map((poolInfo) => ({
        poolId: poolInfo.poolId,
        poolName: poolInfo.poolName,
        availableBalance: poolInfo.availableBalance,
        percentShare: poolInfo.percentShare,
        units: poolInfo.availableUnits,
      }));
      return state
        .setIn(["poolsAllocation"], requiredData)
        .setIn(["investmentAllocationData", "isLoading"], false);
    }
    case actionType.fetchGrantHistoryType: {
      return state
        .setIn(["grantHistoryLoading"], true)
        .setIn(["grantHistory"], [])
        .setIn(["agreementHistory"], [])
        .setIn(["scheduleHistory"], []);
    }
    case actionType.fetchGrantHistorySuccessType: {
      const { grantsForCharity = {} } = action.payload;
      const {
        grants = [],
        activeSchedule = [],
        activeGrantAgreement = [],
      } = grantsForCharity;

      return state
        .setIn(["grantHistoryLoading"], false)
        .setIn(["grantHistory"], grants)
        .setIn(
          ["agreementHistory"],
          filterGrantAgreementData(activeGrantAgreement)
        )
        .setIn(["scheduleHistory"], activeSchedule);
    }
    case actionType.fetchGrantHistoryFailType: {
      return state
        .setIn(["grantHistoryLoading"], true)
        .setIn(["grantHistory"], [])
        .setIn(["agreementHistory"], [])
        .setIn(["scheduleHistory"], []);
    }
    case actionType.fetchPendingGrantType: {
      return state
        .setIn(["pendingGrantsLoading"], true)
        .setIn(["pendingGrants"], [])
        .setIn(["pendingAgreements"], [])
        .setIn(["pendingActiveSchedule"], []);
    }
    case actionType.fetchPendingGrantSuccessType: {
      const { grantsForCharity = {} } = action.payload;
      const {
        grants = [],
        activeSchedule = [],
        activeGrantAgreement = [],
      } = grantsForCharity;

      return state
        .setIn(["pendingGrantsLoading"], false)
        .setIn(["pendingGrants"], grants)
        .setIn(
          ["pendingAgreements"],
          filterGrantAgreementData(activeGrantAgreement)
        )
        .setIn(["pendingActiveSchedule"], activeSchedule);
    }
    case actionType.fetchPendingGrantFailType: {
      return state
        .setIn(["pendingGrantsLoading"], false)
        .setIn(["pendingGrants"], [])
        .setIn(["pendingAgreements"], [])
        .setIn(["pendingActiveSchedule"], []);
    }

    case actionType.selectCharityType: {
      const {
        id,
        name,
        address,
        ein,
        interestArea,
        charityRefPath,
      } = action.payload;
      return state
        .setIn(["selectedCharityId"], id)
        .setIn(["selectedCharityName"], name)
        .setIn(["selectedCharityAddress"], address)
        .setIn(["selectedCharityEin"], ein)
        .setIn(["selectedCharityInterest"], interestArea)
        .setIn(["selectedCharityRefPath"], charityRefPath);
    }
    case actionType.changeScheduleAllocationType: {
      const {
        grantAmount,
        userSelectedDateVal,
        startDate,
        frequency,
        noOfPayments,
        scheduleType,
        allocationPref,
        allocations,
        allSharesAllPools,
        allShares,
      } = action.payload;
      return state
        .setIn(["grantAmount"], grantAmount)
        .setIn(["startDate"], startDate)
        .setIn(["userSelectedDateVal"], userSelectedDateVal)
        .setIn(["frequency"], frequency)
        .setIn(["noOfPayments"], noOfPayments)
        .setIn(["scheduleType"], scheduleType)
        .setIn(["allocationType"], allocationPref)
        .setIn(["allocations"], allocations)
        .setIn(["allSharesAllPools"], allSharesAllPools)
        .setIn(["allShares"], allShares);
    }
    case actionType.changeNumberOfPaymentsType: {
      return state.setIn(["noOfPayments"], action.payload);
    }
    case actionType.enableEditType: {
      return state.setIn(["edit"], true);
    }
    case actionType.resetEditType: {
      return state.setIn(["edit"], false);
    }
    case actionType.changePurposeRecognitionType: {
      const {
        purposeId,
        purposeName,
        additionalComments,
        missionaryName,
        eventName,
        projectName,
        missionaryLocation,
        purposeCertification,
        standardLanguage,
        grantRecognition,
        notifyFirstName,
        notifyLastName,
        inMemoryOfName,
        inHonorOfName,
        thirdParty,
        publishName,
        includeAdvisorInfo,
        accountName,
      } = action.payload;
      return state
        .setIn(["grantPurposeId"], purposeId)
        .setIn(["grantPurposeName"], purposeName)
        .setIn(["purposeComments"], additionalComments)
        .setIn(["missionaryName"], missionaryName)
        .setIn(["eventName"], eventName)
        .setIn(["missionaryLocation"], missionaryLocation)
        .setIn(["projectName"], projectName)
        .setIn(["purposeCertification"], purposeCertification)
        .setIn(["standardLanguage"], standardLanguage)
        .setIn(["grantRecognition"], grantRecognition)
        .setIn(["honorOf"], inHonorOfName)
        .setIn(["memoryOf"], inMemoryOfName)
        .setIn(["notifyFirstName"], notifyFirstName)
        .setIn(["notifyLastName"], notifyLastName)
        .setIn(["advisorThirdPartyComment"], thirdParty)
        .setIn(["permissionToPublish"], publishName)
        .setIn(["accountName"], accountName)
        .setIn(["includeAdvisorInfo"], includeAdvisorInfo);
    }

    case actionType.updateFromType:
      let prevValue = state.get("from");
      prevValue = prevValue + 25;
      let prevData = state.getIn(["searchCharity", "data"]);

      return state.set("from", prevValue).set("lazyLoadingFlag", true);

    case actionType.searchTermType:
      return state.set("searchTerm", action.payload);

    case actionType.geminiSearchTermType:
      return state.set("geminiSearchTerm", action.payload);

    case actionType.searchGeminiResponseType: {
      const searchSavedData = state.getIn(["savedCharities"]);
      if (typeof action.payload === "string") {
        return state
          .setIn(["searchGemini", "searchGeminiStringResponse"], action.payload)
          .setIn(["searchGemini", "data"], [])
          .setIn(["searchGemini", "isLoading"], false)
          .setIn(["searchGemini", "isGeminiSearch"], true);
      }

      if (action.payload.length > 0) {
        action.payload.map((record) => {
          if (record.granteeOrgAliasId !== 0) {
            record.isSelected = false;
            const savedCharityMatch = find(searchSavedData, {
              charityId: parseInt(record.granteeOrgId),
            });
            if (savedCharityMatch) {
              record.isPending = savedCharityMatch.isPending;
              record.charityId = savedCharityMatch.charityId;
              record.isSelected = true;
              record.granteeOrgAliasId = savedCharityMatch.granteeOrgAliasId;
            }
          } else {
            record.isSelected = false;
          }
        });
      }
      return state
        .setIn(["searchGemini", "data"], action.payload)
        .setIn(["searchGemini", "searchGeminiStringResponse"], "")
        .setIn(["searchGemini", "isLoading"], false)
        .setIn(["searchGemini", "isGeminiSearch"], true);
    }

    case actionType.geminiEinDataType: {
      let searchData = state.getIn(["searchGemini", "data"]);
      let searchGeminiData = searchData.splice(0);
      let newSearchGemini;
      newSearchGemini = searchGeminiData.map((obj) => {
        if (obj.ein && obj.ein === action.payload) {
          obj.isSelected = false;
        }
        return obj;
      });
      return state
        .set("geminiEinData", action.payload)
        .setIn(["searchGemini", "data"], newSearchGemini);
    }

    case actionType.cityLoaderType:
      return state.setIn(["cityLoader", "isLoading"], false);

    case actionType.scheduleIdType:
      return state.setIn(["scheduleId"], action.payload);

    case actionType.searchCityResponseType:
      return state
        .setIn(["searchCity", "data"], action.payload)
        .setIn(["searchCity", "isLoading"], false)
        .setIn(["cityLoader", "isLoading"], false);

    case actionType.searchCountrySuccessResponseType:
      return state
        .setIn(["searchCounty", "data"], action.payload)
        .setIn(["searchCounty", "isLoading"], false)
        .setIn(["countyLoader", "isLoading"], false);

    case actionType.updateFromCounterWorkerType:
      let nextCounter = state.get("searchNextApi", action.payload.payload);

      nextCounter = nextCounter + 1;

      return state.set("searchNextApi", nextCounter);

    case actionType.updateFromLoadMoreCounterWorkerType:
      let nextLoadMoreCounter = state.get(
        "searchLoadMoreApi",
        action.payload.payload
      );

      nextLoadMoreCounter = nextLoadMoreCounter + 10;

      return state.set("searchLoadMoreApi", nextLoadMoreCounter);

    case actionType.clearPaymentDetailsType:
      return state
        .setIn(["grantAmount"], 0)
        .setIn(["scheduleType"], "oneTime")
        .setIn(["startDate"], "")
        .setIn(["frequency"], "")
        .setIn(["allocationType"], "")
        .setIn(["allocations"], [])
        .setIn(["noOfPayments"], 0)
        .setIn(["allSharesAllPools"], false)
        .setIn(["allShares"], false);

    case actionType.grantDetailsLoaderType: {
      return state.setIn(["isGrantDetailsLoading"], true);
    }

    case actionType.fetchGrantDetailSuccessType: {
      const {
        charityName: selectedCharityName,
        ein,
        streetAddress,
        line2,
        line3,
        state: _state, // rename state to avoid duplicate with redux state
        city,
        zip,
      } = action.payload.charityDetails;
      const address = {
        addressLine1: streetAddress,
        addressLine2: line2,
        addressLine3: line3,
        state: _state,
        city,
        zipCode: zip,
      };
      // Section that populates Transaction details
      const { charityId } = action.payload;

      // Section that populates Purpose and Recognition Details
      const {
        purpose,
        publishName,
        additionalAttribution,
        purposeId,
        recognitionId,
        additionalComments,
        projectName,
        eventName,
        missionaryName,
        missionaryLocation,
        otherIndDoNotIncAcctAdv,
        type: recogntionType,
        purposeCertification,
        notifyFirstName,
        notifyLastName,
      } = action.payload.recognitionOptions;
      const tempIncludeAdvisorInfo = !(otherIndDoNotIncAcctAdv === "on");

      // Section that populates Payment and Allocation Details
      const {
        payment,
        scheduleEndDate,
        noOfPayments,
        enteredDate,
        amount,
        frequency,
        allocationPreference,
        grantAllocation,
        grantId,
        scheduleId,
        grantAmount,
        spawns,
        status,
        scheduleStatus,
        pendingSpawnId,
        checkIssuedDate,
        allShareallPool,
        allShareSpecificPool,
        checkNumber,
        paymentLetterLink,
        grantTemplateId,
        grantAgreementPayment,
        issueDateStr,
        scheduleStartDateStr,
        grantTimeline,
        fastPass,
        grantAgreementId,
        checkClearedDate
      } = action.payload;

      const paymentType =
        // Single time comes from spawns and single payment from recurring
        payment &&
        (payment.toLowerCase() === "single payment" ||
          payment.toLowerCase() === "single time")
          ? "oneTime"
          : "recurring";
      const grantedAmount = paymentType === "oneTime" ? amount : grantAmount;
      // OW-403 - While calling recurring API in view and edit getting string Semi Annually,
      // while submitting API expecting Semianually
      const recurringFrequency =
        frequency === "Semi Annually" ? "Semiannually" : frequency;

      let startDate =
        paymentType === "oneTime" ? issueDateStr : scheduleStartDateStr;

      if (pendingSpawnId) {
        // Spawn flow. Date is coming in as timestamp unlike grant
        startDate = issueDateStr ? issueDateStr : "—";
        //cant set null because it will default to as soon as possible
      }
      // As per bug OW-677, currently getting start date in string so no need a convert to string format
      startDate = !startDate ? "-" : startDate;

      // recognition id 20 stands for accounts advisors, account and third party
      // third party is being returned as type inside recognitionOptions when id = 20
      let thirdParty = "";
      if (recognitionId === "20") {
        thirdParty = recogntionType;
      }

      const allocationType =
        allocationPreference && reverseMapAllocationType(allocationPreference);
      const allocations = grantAllocation.map((allocation) => {
        const allocCommon = {
          id: allocation.poolId,
          name: allocation.option,
          allShare: allocation.allShareSpecificPool,
        };
        if (allocation.allShareSpecificPool) {
          return {
            ...allocCommon,
            units: String(allocation.value).replace(/\,/g, ""), // Value should be a string
            grantAmount: "",
            grantPercentage: "",
          };
        }
        return {
          ...allocCommon,
          units: 0,
          grantAmount:
            allocationType !== "byPercentage"
              ? allocation.value
              : (
                  (parseFloat(grantedAmount) * parseFloat(allocation.value)) /
                  100
                ).toFixed(2),
          grantPercentage:
            allocationType === "byPercentage"
              ? allocation.value
              : (
                  (parseFloat(allocation.value) / parseFloat(grantedAmount)) *
                  100
                ).toFixed(2),
        };
      });

      return state
        .setIn(["isGrantDetailsLoading"], false)
        .setIn(["selectedCharityName"], selectedCharityName)
        .setIn(["selectedCharityAddress"], address)
        .setIn(["selectedCharityId"], charityId)
        .setIn(["selectedCharityEin"], ein)
        .setIn(["enteredDate"], enteredDate ? dateFormatter(enteredDate) : "")
        .setIn(
          ["checkIssuedDate"],
          checkIssuedDate ? dateFormatter(Number(checkIssuedDate)) : ""
        )
        .setIn(["checkNumber"], checkNumber)
        .setIn(["grantPurposeName"], purpose)
        .setIn(["grantPurposeId"], parseInt(purposeId))
        .setIn(["grantRecognition"], recognitionId)
        .setIn(["honorOf"], additionalAttribution.inHonorOf)
        .setIn(["memoryOf"], additionalAttribution.inMemoryOf)
        .setIn(["notifyFirstName"], notifyFirstName)
        .setIn(["notifyLastName"], notifyLastName)
        .setIn(["permissionToPublish"], publishName === "Yes") // If publishName = "No", then checkbox is checked
        .setIn(["purposeComments"], additionalComments)
        .setIn(["missionaryName"], missionaryName)
        .setIn(["eventName"], eventName)
        .setIn(["missionaryLocation"], missionaryLocation)
        .setIn(["projectName"], projectName)
        .setIn(["purposeCertification"], purposeCertification === "on")
        .setIn(["advisorThirdPartyComment"], thirdParty)
        .setIn(["includeAdvisorInfo"], tempIncludeAdvisorInfo)

        .setIn(["grantAmount"], grantedAmount)
        .setIn(["startDate"], startDate)
        .setIn(
          ["endDate"],
          scheduleEndDate ? dateFormatter(scheduleEndDate) : ""
        )
        .setIn(["frequency"], recurringFrequency)
        .setIn(["noOfPayments"], noOfPayments)
        .setIn(["scheduleType"], paymentType)
        .setIn(["allocationType"], allocationType)
        .setIn(["allocations"], allocations)
        .setIn(["allSharesAllPools"], allShareallPool)
        .setIn(["allShares"], allShareSpecificPool)

        .setIn(["grantId"], grantId)
        .setIn(["scheduleId"], scheduleId)
        .setIn(["spawns"], spawns)
        .setIn(["pendingSpawnId"], pendingSpawnId)
        .setIn(["cancel"], false)
        .setIn(["cancelAll"], false)
        .setIn(["updateSpawn"], false)
        .setIn(["status"], status)
        .setIn(["scheduleStatus"], scheduleStatus)
        .setIn(["paymentLetterLink"], paymentLetterLink)
        .setIn(["grantTemplateId"], grantTemplateId)
        .setIn(["isGrantAgreementPayment"], grantAgreementPayment)
        .setIn(["grantTimeline"], grantTimeline)
        .setIn(["fastPass"], fastPass)
        .setIn(["grantAgreementId"], grantAgreementId)
        .setIn(["checkClearedDate"], checkClearedDate)
    }
    case actionType.needUpdateType: {
      return state.setIn(["updateReq"], true);
    }
    case actionType.updateGrantSuccessType: {
      return state.setIn(["updateReq"], false);
    }
    case actionType.updateGrantFailType: {
      return state
        .setIn(["updateReq"], false)
        .setIn(["updateErrors"], action.payload);
    }
    case actionType.updateClearErrorsType: {
      return state.setIn(["updateErrors"], []);
    }
    case actionType.cancelScheduleSuccessType: {
      return state.setIn(["cancel"], true).updateIn(["spawns"], (spawns) =>
        spawns.map((spawn) => {
          if (spawn.spawnId === action.payload) spawn.status = "Cancelled";
          return spawn;
        })
      );
    }

    case actionType.cancelAllScheduleSuccessType: {
      return state.setIn(["cancelAll"], true);
    }
    case actionType.addSpawnSuccessType: {
      return state
        .updateIn(["spawns"], (item) => {
          const copy = [...item];
          copy.push(action.payload);
          return copy;
        })
        .updateIn(["noOfPayments"], (payments) => parseInt(payments) + 1)
        .updateIn(["endDate"], (endDate) =>
          dateFormatter(parseFloat(action.payload.issueDate))
        );
    }
    case actionType.updateSpawnSuccessType: {
      return state.setIn(["updateSpawn"], true);
    }
    case actionType.submitGrantType: {
      return state.setIn(["submitLoading"], true);
    }
    case actionType.submitGrantFailType:
    case actionType.submitGrantSuccessType: {
      return state.setIn(["submitLoading"], false);
    }
    case actionType.reGrantType: {
      return state.setIn(["startDate"], "").setIn(["regrant"], true);
    }
    case actionType.poolsPendingAdminFeeType: {
      return state.setIn(["contribAndFeeLoading"], true);
    }
    case actionType.fetchPoolsPendingContributionSuccessType: {
      const poolsPendingContrib = action.payload;
      return state.setIn(["poolsPendingContrib"], poolsPendingContrib);
    }
    case actionType.fetchAdminFeeSuccessType: {
      const { adminFeeAmount } = action.payload;
      return state.setIn(["adminFee"], adminFeeAmount);
    }
    case actionType.fetchPoolsPendingAdminFeeSuccessType: {
      return state.setIn(["contribAndFeeLoading"], false);
    }
    case actionType.fetchPoolsPendingAdminFeeFailType: {
      return state
        .setIn(["poolsPendingContrib"], [])
        .setIn(["adminFee"], 0)
        .setIn(["contribAndFeeLoading"], false);
    }
    case actionType.clearAllFilterType: {
      return state.setIn(["searchCharity", "isCharitySearch"], false);
    }
    case actionType.clearAllGeminiFilterType: {
      return state.setIn(["searchGemini", "isGeminiSearch"], false);
    }

    case actionType.exhaustCheckType: {
      return state.setIn(["allocExhaustChecked"], true);
    }
    case actionType.pageScrollType:
      return state.setIn(["currentPageScroll"], action.payload);

    case actionType.addProjectNameType: {
      return state.setIn(["project"], action.payload);
    }

    case actionType.addPurposeType: {
      return state.setIn(["purpose"], action.payload);
    }

    case actionType.addEventNameType: {
      return state.setIn(["eventName"], action.payload);
    }

    case actionType.addMissionaryNameType: {
      return state.setIn(["missionaryNames"], action.payload);
    }

    case actionType.addMissionaryLocationType: {
      return state.setIn(["missionaryLocations"], action.payload);
    }

    case actionType.removeCharitySuccessType: {
      if (action.payload.payload.searchType === "gemini") {
        const searchGemini = state.getIn(["searchGemini", "data"]);
        if (searchGemini && searchGemini.length) {
          searchGemini.map((data) => {
            if (
              data.granteeOrgAliasId &&
              data.granteeOrgAliasId == action.payload.payload.charityId
            ) {
              data.isPending = false;
              data.isSelected = false;
            }
          });
        }
        return state.setIn(["searchGemini", "data"], searchGemini);
      } else {
        let searchData = state.getIn(["searchCharity", "data"]);
        if (searchData && searchData.length) {
          searchData.map((data) => {
            if (
              data.granteeOrgAliasId &&
              data.granteeOrgAliasId == action.payload.payload.charityId
            ) {
              data.isPending = false;
              data.isSelected = false;
            }
          });
        }
        return state.setIn(["searchCharity", "data"], searchData);
      }
    }

    default:
      return state;
  }
};

export default recommendGrant;
